import { AppComponent } from '../components/app.component'
import { User, LoginRequest } from '../lib/LoginUtilities'
import { Injectable } from '@angular/core';
import { LanguageService } from '../services/language.service';


// #########################################################################
//
// This service is used to manage the login-state
//
// #########################################################################

declare var swal: any;

@Injectable()
export class LoginService {
    public currentUser: User = null;
    private userpassword = "";
    public static self: LoginService = null;
    private userStatus = '../src/app/img/navigation/logged_out.png';

    constructor(private languageService: LanguageService) {
        (<any>window).tryRegister = this.tryRegister;
        (<any>window).logout = this.logout;
        LoginService.self = this;
        (<any>window).performLogin = this.performLogin
    }

    public setUserPassword(password){
        this.userpassword = password;
    }

    public getUserPassword(){
        return this.userpassword;
    }

    /**
     * @returns true iff a user is currently logged in
     */
    public isLoggedIn(): boolean {
        return this.currentUser != null;
    }

    /**
     * @returns current user if logged in and null otherwise
     */
    public getUser(): User {
        return this.currentUser;
    }

    /**
     * @returns icon correwsponding user login status
     */
    public getIconUserStatus() {
        return this.userStatus;
    }

    /**
     * Helper function to display that something went wrong during the registration process.
     * Asks if user wants to try again and upon confirm recalls this.tryRegister()
     */
    private async somethingWentWrongTryAgainRegister(title_: string, text_: string) {
        swal({
            title: title_,
            text: text_,
            showCancelButton: true,
            confirmButtonText: this.languageService.getLang()["tryAgain"]
        }).then(async () => {
            await this.tryRegister();
        })
    }

    /**
     * Helper function to display that something went wrong during the login process.
     * * Asks if user wants to try again and upon confirm recalls this.tryLogin()
     */
    private async somethingWentWrongTryAgainLogin(title_: string, text_: string) {
        swal({
            title: title_,
            text: text_,
            showCancelButton: true,
            confirmButtonText: this.languageService.getLang()["tryAgain"]
        }).then(async () => {
            return await this.tryLogin();
        })
    }

    /**
     * Reads the string value out of a html-inputelement and deletes that value in the element
     * @param id identifiert of the html elemen
     */
    private getTextInputAndResetOriginal(id: string): string {
        var element: HTMLInputElement = <HTMLInputElement>document.getElementById(id);
        var elementvalue: string = element.value;
        element.value = '';
        return elementvalue;
    }

    /**
     * Helper function to display an alert
     */
    private async ownAlert(title_: string, text_: string, showConfirm_: boolean) {
        swal({
            title: title_,
            text: text_,
            type: "success",
            showConfirmButton: showConfirm_
        })
    }

    /**
     * Guides user through registration process by asking for wanted credentials. Process ends either by explicit
     * user abbortion or a successful login.
     */
    private async tryRegister() {
        await swal({
            title: LoginService.self.languageService.getLang()["registerTitle"],
            html: "<input type='text' id='swal-register-username' class='swal2-input' placeholder=\"" + LoginService.self.languageService.getLang()["username"] + "\" autofocus> " +
                "<input type='password' id='swal-register-password' class='swal2-input' placeholder=\"" + LoginService.self.languageService.getLang()["password"] + "\">" +
                "<input type='password' id='swal-register-password-rep' class='swal2-input' placeholder=\"" + LoginService.self.languageService.getLang()["repeatPassword"] + "\">" +
                "<input type='checkbox' id='datenschutz'> "+LoginService.self.languageService.getLang()["Ihaveread"]+" <a href=\"https://xlogo.inf.ethz.ch/datenschutz.html\">"+LoginService.self.languageService.getLang()["datenschutz"]+"</a> "+LoginService.self.languageService.getLang()["readandaccepted"]+" <br>",
            showCancelButton: true
        }).then(async function(){
            //Datenschutzerklärung akzeptieren
            var agree = (<any>document.getElementById("datenschutz")).checked;

            //if datenschutz not agreed --> remind and start over
            if(!agree){
                var usernamebefore = (<any>document.getElementById("swal-register-username")).value;
                var passwordbefore = (<any>document.getElementById("swal-register-password")).value;
                var password2before = (<any>document.getElementById("swal-register-password-rep")).value;
                await swal({title: "Fehler", text : "Bitte Datenschutzerklärung akzeptieren", type: "error"});
                LoginService.self.tryRegister();
                (<any>document.getElementById("swal-register-username")).value = usernamebefore;
                (<any>document.getElementById("swal-register-password")).value = passwordbefore;
                (<any>document.getElementById("swal-register-password-rep")).value = password2before;
                return;
            }

            var username: string = LoginService.self.getTextInputAndResetOriginal("swal-register-username");
            var password: string = LoginService.self.getTextInputAndResetOriginal("swal-register-password");
            var repeatedPassword: string = LoginService.self.getTextInputAndResetOriginal("swal-register-password-rep");
            if (password !== repeatedPassword) {
                //User failed to repeat password correctly
                await LoginService.self.somethingWentWrongTryAgainRegister(LoginService.self.languageService.getLang()["passwordMisatchTitle"], LoginService.self.languageService.getLang()["passwordMisatchText"]);
            } else {
                await LoginRequest.performLoginRequest(username, password, true).then(async (loginRequest: LoginRequest) => {
                    //SUCCESS
                    console.log("LOGINSERVICE: SUCCESS");
                    LoginService.self.currentUser = loginRequest.user;
                    await LoginService.self.ownAlert(LoginService.self.languageService.getLang()["successfulRegistrationTitle"], LoginService.self.languageService.getLang()["successfulRegistrationText"] + LoginService.self.currentUser.getUsername() + "!", true);
                    LoginService.self.visualizeOnline();
                }, async (loginRequest: LoginRequest) => {
                    //FAIL
                    console.log("LOGINSERVICE: FAIL");
                    var errorMessage: string = loginRequest.errorString;
                    await LoginService.self.somethingWentWrongTryAgainRegister(LoginService.self.languageService.getLang()["failLoginTitle"], LoginService.self.languageService.getLang()[errorMessage]);
                })
            }
        }.bind(this), (async () => {

        }),
            () => {
                //do nothing if user aborts
                return null;
            })
            .catch((error) => {});
    }

    /**
     * logs out the user that is currently logged in. If no user is logged in, this method has no effect.
     */
    public logout() {
        LoginService.self.currentUser = null;
        this.languageService.setHeaderText("XLogoOnline");
        document.getElementById("loginbutton").style.backgroundColor = "#4CAF50";
        this.userStatus = '../src/app/img/navigation/logged_out.png';
    }

//showLoaderOnConfirm: true,

    private async performLogin(){
        if (LoginService.self.currentUser != null) {
            //TODO: do we need to set the headertext so often?
            //TODO: arrived here via register
            console.log("Successful login via registration");
            await LoginService.self.ownAlert(LoginService.self.languageService.getLang()["successfulLoginTitle"], LoginService.self.languageService.getLang()["successfulLoginText"] + LoginService.self.currentUser.getUsername(), true);
            LoginService.self.visualizeOnline();
            //resolve("login");
            return "login";
        } else {
            var uname: string = LoginService.self.getTextInputAndResetOriginal("swal-username").trim();
            var pw: string = LoginService.self.getTextInputAndResetOriginal("swal-password");
            await LoginRequest.performLoginRequest(uname, pw, false).then(async (loginRequest: LoginRequest) => {
                //SUCCESS
                LoginService.self.currentUser = loginRequest.user;
                await LoginService.self.ownAlert(LoginService.self.languageService.getLang()["successfulLoginTitle"], LoginService.self.languageService.getLang()["successfulLoginText"] + LoginService.self.currentUser.getUsername(), false);
                LoginService.self.visualizeOnline();
                LoginService.self.setUserPassword(pw);
                setTimeout(() => {
                    swal({position: 'top-end', type: "info", text: LoginService.self.languageService.getLang()["youcanloadandstore"], background: "#ffbb00", showConfirmButton: false, timer: 4000});
                }, 1500);
                //resolve("login");
                return "login";
            }, async (loginRequest: LoginRequest) => {
                //FAIL
                var errorMessage: string = loginRequest.errorString;
                await LoginService.self.somethingWentWrongTryAgainLogin(LoginService.self.languageService.getLang()["failLoginTitle"], LoginService.self.languageService.getLang()[errorMessage]);
                //resolve("cancel");
                return "cancel";
            })
        }
    }

    /**
     * Tries to login a user according to credentials a user provides
     */
    public async tryLogin() {
        return new Promise(async (resolve, reject) => {
            //if already logged in --> log out again
            if (LoginService.self.isLoggedIn()) {
                this.logout();
                resolve("logout");
                return "logout";
            }

            //check whether network connection available
            if (!navigator.onLine) {
                swal({ title: this.languageService.getLang()["noconnection"], type: "error" });
                resolve("cancel");
                return "cancel";
            }

            //otherwise --> advertize login scheme
            if (!this.isLoggedIn()) {
                await swal({
                    title: this.languageService.getLang()["loginTitle"],
                    html: "<input type='text' id='swal-username' class='swal2-input' onkeypress='if (event.keyCode == 13) {window.performLogin()}' placeholder=\"" + this.languageService.getLang()["username"] + "\" autofocus> " +
                        "<input type='password' id='swal-password' class='swal2-input' onkeypress='if (event.keyCode == 13) {window.performLogin()}' placeholder=\"" + this.languageService.getLang()["password"] + "\">" +
                        "<div onClick='tryRegister()' class='registerbutton'> " + this.languageService.getLang()["registerButton"] + "</div>",
                    showCancelButton: true, cancelButtonText: this.languageService.getLang()["cancel"]
                }).then(async () => {
                    await this.performLogin();
                }, (async () => {

                }),
                    () => {
                        //do nothing if user aborts
                        resolve("cancel");
                        return "cancel";
                    }
                ).catch(error => {
                    //do nothing
                });
            }
        });
    }

    public visualizeOnline() {
        this.languageService.setHeaderText(LoginService.self.currentUser.getUsername());
        this.languageService.setHeadLineTextTo(this.languageService.getLang()['XLogoOnline'], this.languageService.getLang()['XLogoOnlineColor']);
        document.getElementById("loginbutton").style.backgroundColor = "orange";
        this.userStatus = '../src/app/img/navigation/logged_in.png';
    }
}


// WEBPACK FOOTER //
// ./src/app/services/login.service.ts